import { useEffect, useState } from 'react';
import './PolicyPage.css';
import ReasonNav from '../components/reason/ReasonNav';
import ReasonFooter from '../components/reason/ReasonFooter';
import { PrivacyContent } from '../data/privacyContent';

function PrivacyPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const root = document.getElementById('root');
    const prevRootBg = root?.style.backgroundColor;
    if (root) root.style.backgroundColor = '#111013';
    return () => {
      document.body.style.overflow = '';
      if (root) root.style.backgroundColor = prevRootBg || '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  return (
    <div className={`reason-page privacy-page${menuOpen ? ' menu-open' : ''}`}>
      <ReasonNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="container mx-auto vote-body">
        <h2>PRIVACY POLICY</h2>
      </div>

      <div className="container main-container policy-body">
        <div className="row col-md-12">
          <PrivacyContent />
        </div>
      </div>

      <ReasonFooter />
    </div>
  );
}

export default PrivacyPage;
